export default __webpack_public_path__ + "static/media/test-foto1.bbec9366.jpg";